module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Send-e5f2bcbbee0c98562639a962807ab268.svg";